import logo from 'assets/images/LogoWellbeing360.png';
import {useForm} from "react-hook-form";
import {useContext, useEffect, useState} from "react";
import axios from "axios";
import {config} from "../../../config";
import {useNavigate, useLocation} from "react-router-dom";
import toast from "react-hot-toast";
import {AppContext} from "contexts/AppContext";
import {FormattedMessage} from "react-intl";
import DropdownItem from "./dropdown";
import CountryItem from './countries';
import ReactPixel from "react-facebook-pixel";
import {useSearchParams} from 'react-router-dom';
import ReactGA from "react-ga4";
import useAuth from "hooks/useAuth";

function IsNumer(number) {
    try {
        parseInt(number)
        return true
    } catch (e) {
        return false
    }
}

const SignUp = () => {
    const context = useContext(AppContext)
    const [searchParams] = useSearchParams();
    const specialRegister = false;
    useEffect(() => {
        window.scrollTo(0, 0);
        ReactPixel.track(`REGISTRATION`);
        // ReactGA.send({hitType: "pageview", page: `/sign-up`, title: `Wellbeing360 - REGISTRATION`});
        console.log("window", window.ttq)
        if (typeof window !== 'undefined' && window.ttq) {
            window.ttq.track('Registration');
        }
        if (typeof window !== 'undefined') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'sign_up_view'
            });
        }
        // LinkedIn: vista/intent de registro (si hay conversion_id configurado)
        if (typeof window !== 'undefined' && window.lintrk) {
            const viewId = process.env.REACT_APP_LINKEDIN_CONVERSION_VIEW_ID;
            if (viewId) {
                try {
                    window.lintrk('track', {conversion_id: viewId});
                } catch (e) {
                    // silenciar opcionalmente
                }
            } else {
                if (process.env.NODE_ENV !== 'production') {
                    console.warn('LinkedIn: REACT_APP_LINKEDIN_CONVERSION_VIEW_ID no definido');
                }
            }
        }
    }, []);
    // POST user-sign-up
    axios.defaults.baseURL = config.api_endpoint;
    const codes = [
        {country: "Afganistán", code: "+93"},
        {country: "Albania", code: "+355"},
        {country: "Alemania", code: "+49"},
        {country: "Andorra", code: "+376"},
        {country: "Angola", code: "+244"},
        {country: "Anguila", code: "+1"},
        {country: "Antigua y B", code: "+1"},
        {country: "Antillas", code: "+599"},
        {country: "Argelia", code: "+213"},
        {country: "Argentina", code: "+54"},
        {country: "Armenia", code: "+374"},
        {country: "Aruba", code: "+297"},
        {country: "Ascención", code: "+247"},
        {country: "Australia", code: "+61"},
        {country: "Austria", code: "+43"},
        {country: "Azerbaiyán", code: "+994"},
        {country: "Bahamas", code: "+1"},
        {country: "Bahrein", code: "+973"},
        {country: "Bangladesh", code: "+880"},
        {country: "Barbados", code: "+1"},
        {country: "Bélgica", code: "+32"},
        {country: "Belice", code: "+501"},
        {country: "Benín", code: "+229"},
        {country: "Bermudas", code: "+1"},
        {country: "Bielorrusia", code: "+375"},
        {country: "Birmania", code: "+95"},
        {country: "Bolivia", code: "+591"},
        {country: "Bosnia", code: "+387"},
        {country: "Botsuana", code: "+267"},
        {country: "Brasil", code: "+55"},
        {country: "Brunei", code: "+673"},
        {country: "Bulgaria", code: "+359"},
        {country: "Burkina Faso", code: "+226"},
        {country: "Burundi", code: "+257"},
        {country: "Bután", code: "+975"},
        {country: "Cabo Verde", code: "+238"},
        {country: "Camboya", code: "+855"},
        {country: "Camerún", code: "+237"},
        {country: "Canadá", code: "+1"},
        {country: "Chad", code: "+235"},
        {country: "Chile", code: "+56"},
        {country: "China", code: "+86"},
        {country: "Chipre", code: "+357"},
        {country: "Colombia", code: "+57"},
        {country: "Comoras", code: "+269"},
        {country: "Congo", code: "+242"},
        {country: "Congo", code: "+243"},
        {country: "Corea N", code: "+850"},
        {country: "Corea S", code: "+82"},
        {country: "Costa Marfil", code: "+225"},
        {country: "Costa Rica", code: "+506"},
        {country: "Croacia", code: "+385"},
        {country: "Cuba", code: "+53"},
        {country: "D.T.F.O.Í.", code: "+262"},
        {country: "Diego García", code: "+246"},
        {country: "Dinamarca", code: "+45"},
        {country: "Dominica", code: "+1"},
        {country: "Ecuador", code: "+593"},
        {country: "Egipto", code: "+20"},
        {country: "El Salvador", code: "+503"},
        {country: "Emiratos Á U", code: "+971"},
        {country: "Eritrea", code: "+291"},
        {country: "Eslovaquia", code: "+421"},
        {country: "Eslovenia", code: "+386"},
        {country: "España", code: "+34"},
        {country: "Estados Unidos", code: "+1"},
        {country: "Estonia", code: "+372"},
        {country: "Etiopía", code: "+251"},
        {country: "Filipinas", code: "+63"},
        {country: "Finlandia", code: "+358"},
        {country: "Fiyi", code: "+679"},
        {country: "Francia", code: "+33"},
        {country: "Gabón", code: "+241"},
        {country: "Gambia", code: "+220"},
        {country: "Georgia", code: "+995"},
        {country: "Ghana", code: "+233"},
        {country: "Gibraltar", code: "+350"},
        {country: "Granada", code: "+1"},
        {country: "Groenlandia", code: "+299"},
        {country: "Guadalupe", code: "+590"},
        {country: "Guam", code: "+1"},
        {country: "Guatemala", code: "+502"},
        {country: "Guayana Fran.", code: "+594"},
        {country: "Guinea", code: "+224"},
        {country: "Guinea Ecua.", code: "+240"},
        {country: "Guinea-Bissau", code: "+245"},
        {country: "Guyana", code: "+592"},
        {country: "Haití", code: "+509"},
        {country: "Honduras", code: "+504"},
        {country: "Hong Kong", code: "+852"},
        {country: "Hungría", code: "+36"},
        {country: "India", code: "+91"},
        {country: "Indonesia", code: "+62"},
        {country: "Irak", code: "+964"},
        {country: "Irán", code: "+98"},
        {country: "Irlanda", code: "+353"},
        {country: "Islandia", code: "+354"},
        {country: "I. Caimán", code: "+1"},
        {country: "I. Cook", code: "+682"},
        {country: "I. Feroe", code: "+298"},
        {country: "I. Malvinas", code: "+500"},
        {country: "I. Marshall", code: "+692"},
        {country: "I. Salomón", code: "+677"},
        {country: "I. Turcas y Caicos", code: "+1"},
        {country: "I. Vírgenes", code: "+1"},
        {country: "I. V. Británicas", code: "+1"},
        {country: "Israel", code: "+972"},
        {country: "Italia", code: "+39"},
        {country: "Jamaica", code: "+1"},
        {country: "Japón", code: "+81"},
        {country: "Jordania", code: "+962"},
        {country: "Kazajstán", code: "+7"},
        {country: "Kenia", code: "+254"},
        {country: "Kirguistán", code: "+996"},
        {country: "Kiribati", code: "+686"},
        {country: "Kuwait", code: "+965"},
        {country: "Laos", code: "+856"},
        {country: "Lesotho", code: "+266"},
        {country: "Letonia", code: "+371"},
        {country: "Líbano", code: "+961"},
        {country: "Liberia", code: "+231"},
        {country: "Libia", code: "+218"},
        {country: "Liechtenstein", code: "+423"},
        {country: "Lituania", code: "+370"},
        {country: "Luxemburgo", code: "+352"},
        {country: "Macao", code: "+853"},
        {country: "Macedonia", code: "+389"},
        {country: "Madagascar", code: "+261"},
        {country: "Malasia", code: "+60"},
        {country: "Malawi", code: "+265"},
        {country: "Maldivas", code: "+960"},
        {country: "Malí", code: "+223"},
        {country: "Malta", code: "+356"},
        {country: "Marruecos", code: "+212"},
        {country: "Martinica", code: "+596"},
        {country: "Mauricio", code: "+230"},
        {country: "Mauritania", code: "+222"},
        {country: "Mayotte", code: "+269"},
        {country: "México", code: "+52"},
        {country: "Micronesia", code: "+691"},
        {country: "Moldavia", code: "+373"},
        {country: "Mónaco", code: "+377"},
        {country: "Mongolia", code: "+976"},
        {country: "Montenegro", code: "+382"},
        {country: "Montserrat", code: "+1"},
        {country: "Mozambique", code: "+258"},
        {country: "Namibia", code: "+264"},
        {country: "Nauru", code: "+674"},
        {country: "Nepal", code: "+977"},
        {country: "Nicaragua", code: "+505"},
        {country: "Níger", code: "+227"},
        {country: "Nigeria", code: "+234"},
        {country: "Niue", code: "+683"},
        {country: "Noruega", code: "+47"},
        {country: "Nueva Caledonia", code: "+687"},
        {country: "Nueva Zelanda", code: "+64"},
        {country: "Omán", code: "+968"},
        {country: "Países Bajos", code: "+31"},
        {country: "Pakistán", code: "+92"},
        {country: "Palau", code: "+680"},
        {country: "Panamá", code: "+507"},
        {country: "PNG.", code: "+675"},
        {country: "Paraguay", code: "+595"},
        {country: "Perú", code: "+51"},
        {country: "Polinesia F.", code: "+689"},
        {country: "Polonia", code: "+48"},
        {country: "Portugal", code: "+351"},
        {country: "Puerto Rico", code: "+1"},
        {country: "Qatar", code: "+974"},
        {country: "Reino Unido", code: "+44"},
        {country: "Rep. CAF.", code: "+236"},
        {country: "Rep. Checa", code: "+420"},
        {country: "Rep. DOM.", code: "+1"},
        {country: "Ruanda", code: "+250"},
        {country: "Rumanía", code: "+40"},
        {country: "Rusia", code: "+7"},
        {country: "Sahara Occ.", code: "+212"},
        {country: "Samoa", code: "+685"},
        {country: "Samoa Americana", code: "+1"},
        {country: "San Cristóbal N.", code: "+1"},
        {country: "San Marino", code: "+378"},
        {country: "San Pedro M.", code: "+508"},
        {country: "VC y VCT.", code: "+1"},
        {country: "VC y VCT.", code: "+966"},
        {country: "ST. Helena", code: "+290"},
        {country: "ST. Lucía", code: "+1"},
        {country: "ST. Sede", code: "+379"},
        {country: "ST. T. Prín.", code: "+239"},
        {country: "Senegal", code: "+221"},
        {country: "Serbia", code: "+381"},
        {country: "Seychelles", code: "+248"},
        {country: "Sierra Leona", code: "+232"},
        {country: "Singapur", code: "+65"},
        {country: "Siria", code: "+963"},
        {country: "Somalia", code: "+252"},
        {country: "Sri Lanka", code: "+94"},
        {country: "Suazilandia", code: "+268"},
        {country: "Sudáfrica", code: "+27"},
        {country: "Sudán", code: "+249"},
        {country: "Suecia", code: "+46"},
        {country: "Suiza", code: "+41"},
        {country: "Surinam", code: "+597"},
        {country: "Tailandia", code: "+66"},
        {country: "Taiwán", code: "+886"},
        {country: "Tanzania", code: "+255"},
        {country: "Tayikistán", code: "+992"},
        {country: "Terr. del Norte", code: "+1"},
        {country: "Timor-Leste", code: "+670"},
        {country: "Togo", code: "+228"},
        {country: "Tokelau", code: "+690"},
        {country: "Tonga", code: "+676"},
        {country: "Trinidad y Tobago", code: "+1"},
        {country: "Túnez", code: "+216"},
        {country: "Turkmenistán", code: "+993"},
        {country: "Turquía", code: "+90"},
        {country: "Tuvalu", code: "+688"},
        {country: "Ucrania", code: "+380"},
        {country: "Uganda", code: "+256"},
        {country: "Uruguay", code: "+598"},
        {country: "Uzbekistán", code: "+998"},
        {country: "Vanuatu", code: "+678"},
        {country: "Venezuela", code: "+58"},
        {country: "Vietnam", code: "+84"},
        {country: "Wallis y Futuna", code: "+681"},
        {country: "Yemen", code: "+967"},
        {country: "Yibuti", code: "+253"},
        {country: "Zambia", code: "+260"},
        {country: "Zimbabue", code: "+263"}
    ]

    const countries = [{'country': 'Afganist'}, {'country': 'Albania'}, {'country': 'Alemania'}, {'country': 'Andorra'}, {'country': 'Angola'}, {'country': 'Anguila'}, {'country': 'Antártida'}, {'country': 'Antigua y Barbuda'}, {'country': 'Antillas Holandesas'}, {'country': 'Arabia Saudita'}, {'country': 'Argelia'}, {'country': 'Argentina'}, {'country': 'Armenia'}, {'country': 'Aruba'}, {'country': 'Australia'}, {'country': 'Austria'}, {'country': 'Azerbaiyán Azerbaiy\\\\303\\\\241n\\'}, {'country': 'Bahamas'}, {'country': 'Bahrein'}, {'country': 'Bangladesh'}, {'country': 'Barbados'}, {'country': 'B\\\\303\\\\251lgica Bélgica'}, {'country': 'Belice'}, {'country': 'Benin'}, {'country': 'Bielorrusia'}, {'country': 'Bolivia'}, {'country': 'Bosnia y Herzegovina'}, {'country': 'Botsuana'}, {'country': 'Brasil'}, {'country': 'Brunei'}, {'country': 'Bulgaria'}, {'country': 'Burkina Faso'}, {'country': 'Burundi'}, {'country': 'Bután'}, {'country': 'Cabo Verde'}, {'country': 'Camboya'}, {'country': 'Camerún'}, {'country': 'Canadá Canad\\\\303\\\\241'}, {'country': 'Caribe Holandás'}, {'country': 'Chad'}, {'country': 'Chile'}, {'country': 'China'}, {'country': 'Chipre'}, {'country': 'Ciudad del Vaticano'}, {'country': 'Colombia'}, {'country': 'Comoras'}, {'country': 'Congo'}, {'country': 'Corea del Norte'}, {'country': 'Corea del Sur'}, {'country': 'Costa de Marfil'}, {'country': 'Costa Rica'}, {'country': 'Croacia'}, {'country': 'Cuba'}, {'country': 'Curazao'}, {'country': 'Dinamarca'}, {'country': 'Djibouti'}, {'country': 'Dominica'}, {'country': 'Ecuador'}, {'country': 'Egipto'}, {'country': 'El Salvador'}, {'country': 'Emiratos Árabes Unidos'}, {'country': 'Eritrea'}, {'country': 'Eslovaquia'}, {'country': 'Eslovenia'}, {'country': 'España'}, {'country': 'Estados Unidos'}, {'country': 'Estonia'}, {'country': 'Etiopía'}, {'country': 'Europa'}, {'country': 'Filipinas'}, {'country': 'Finlandia'}, {'country': 'Fiyi'}, {'country': 'Francia'}, {'country': 'Gabón'}, {'country': 'Gambia'}, {'country': 'Georgia'}, {'country': 'Georgia del sur y las islas Sandwich del sur'}, {'country': 'Ghana'}, {'country': 'Gibraltar'}, {'country': 'Granada'}, {'country': 'Grecia'}, {'country': 'Groenlandia'}, {'country': 'Guadalupe'}, {'country': 'Guam'}, {'country': 'Guatemala'}, {'country': 'Guayana'}, {'country': 'Guayana Francesa'}, {'country': 'Guernsey'}, {'country': 'Guinea'}, {'country': 'Guinea Ecuatorial'}, {'country': 'Guinea-Bissau'}, {'country': 'Haití'}, {'country': 'Honduras'}, {'country': 'Hong Kong'}, {'country': 'Hungría'}, {'country': 'India'}, {'country': 'Indonesia'}, {'country': 'Irak'}, {'country': 'Irán'}, {'country': 'Irlanda'}, {'country': 'Isla Bouvet'}, {'country': 'Isla de Navidad'}, {'country': 'Isla del hombre'}, {'country': 'Isla Norfolk'}, {'country': 'Islandia'}, {'country': 'Islas Aland'}, {'country': 'islas Bermudas'}, {'country': 'Islas Caimán'}, {'country': 'Islas Cocos (Keeling)'}, {'country': 'Islas Cook'}, {'country': 'Islas Faroe'}, {'country': 'Islas Heard y McDonald'}, {'country': 'Islas Malvinas'}, {'country': 'Islas Marianas del Norte'}, {'country': 'Islas Marshall'}, {'country': 'Islas menores alejadas de los Estados Unidos'}, {'country': 'Islas Pitcairn'}, {'country': 'Islas Salomón'}, {'country': 'Islas Turcas y Caicos'}, {'country': 'Islas Vírgenes Británicas'}, {'country': 'Islas Vírgenes de EE.UU'}, {'country': 'Israel'}, {'country': 'Italia'}, {'country': 'Jamaica'}, {'country': 'Japón'}, {'country': 'Jersey'}, {'country': 'Jordán'}, {'country': 'Katar'}, {'country': 'Kazajstán'}, {'country': 'Kenia'}, {'country': 'Kirguizstán'}, {'country': 'Kiribati'}, {'country': 'Kosovo'}, {'country': 'Kuwait'}, {'country': 'Laos'}, {'country': 'Lesoto'}, {'country': 'Letonia'}, {'country': 'Líbano'}, {'country': 'Liberia'}, {'country': 'Libia'}, {'country': 'Liechtenstein'}, {'country': 'Lituania'}, {'country': 'Luxemburgo'}, {'country': 'Macau'}, {'country': 'Macedonia (ARYM)'}, {'country': 'Madagascar'}, {'country': 'Malawi'}, {'country': 'Maldivas'}, {'country': 'Mali'}, {'country': 'Marruecos'}, {'country': 'Martinica'}, {'country': 'Mauricio'}, {'country': 'Mauritania'}, {'country': 'Mayotte'}, {'country': 'México'}, {'country': 'Micronesia'}, {'country': 'Moldavia'}, {'country': 'Mónaco'}, {'country': 'Mongolia'}, {'country': 'Montenegro'}, {'country': 'Montserrat'}, {'country': 'Mozambique'}, {'country': 'Myanmar (Birmania)'}, {'country': 'Namibia'}, {'country': 'Nauru'}, {'country': 'Nepal'}, {'country': 'Nicaragua'}, {'country': 'Níger'}, {'country': 'Nigeria'}, {'country': 'Niue'}, {'country': 'Noruega'}, {'country': 'Nueva Caledonia'}, {'country': 'Nueva Zelanda'}, {'country': 'Omán'}, {'country': 'Países Bajos'}, {'country': 'Pakistán'}, {'country': 'Palau'}, {'country': 'Palestina'}, {'country': 'Panamá'}, {'country': 'Papúa Nueva Guinea'}, {'country': 'Paraguay'}, {'country': 'Perú'}, {'country': 'Polinesia Francesa'}, {'country': 'Polonia'}, {'country': 'Portugal'}, {'country': 'Puerto Rico'}, {'country': 'Región Asia Pacífico'}, {'country': 'Reino Unido'}, {'country': 'República Centroafricana'}, {'country': 'Republica checa'}, {'country': 'República Democrática del Congo'}, {'country': 'Reública Dominicana'}, {'country': 'Reunión'}, {'country': 'Ruanda'}, {'country': 'Rumania'}, {'country': 'Rusia'}, {'country': 'Sahara Occidental'}, {'country': 'Samoa'}, {'country': 'Samoa Americana'}, {'country': 'San Bartolomé'}, {'country': 'San Cristóbal y Nieves'}, {'country': 'San Marino'}, {'country': 'San Martín'}, {'country': 'San Pedro y Miquelón'}, {'country': 'San Vicente y las Granadinas'}, {'country': 'Santa helena'}, {'country': 'Santa Lucía'}, {'country': 'Santo Tomé y Príncipe'}, {'country': 'Senegal'}, {'country': 'Serbia'}, {'country': 'Seychelles'}, {'country': 'Sierra Leona'}, {'country': 'Singapur'}, {'country': 'Siria'}, {'country': 'Somalia'}, {'country': 'Sri Lanka'}, {'country': 'Suazilandia'}, {'country': 'Sudáfrica'}, {'country': 'Sudán'}, {'country': 'Sudán del Sur'}, {'country': 'Suecia'}, {'country': 'Suiza'}, {'country': 'Surinam'}, {'country': 'Svalbard y Jan Mayen'}, {'country': 'Tailandia'}, {'country': 'Taiwán'}, {'country': 'Tanzania'}, {'country': 'Tayikistan'}, {'country': 'Territorio Británico del Océano índico'}, {'country': 'Tierras australes y antárticas francesas'}, {'country': 'Timor oriental'}, {'country': 'Togo'}, {'country': 'Tokelau'}, {'country': 'Tonga'}, {'country': 'Trinidad y Tobago'}, {'country': 'Túnez'}, {'country': 'Turkmenistan'}, {'country': 'Turquía'}, {'country': 'Tuvalu'}, {'country': 'Ucrania'}, {'country': 'Uganda'}, {'country': 'Uruguay'}, {'country': 'Uzbekistán'}, {'country': 'Vanuatu'}, {'country': 'Venezuela'}, {'country': 'Vietnam'}, {'country': 'Wallis y Futuna'}, {'country': 'Yemen'}, {'country': 'Zambia'}, {'country': 'Zimbabue'}]

    let navigate = useNavigate();
    let location = useLocation();
    const [isWaitingForRegister, setIsWaitingForRegister] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);

    useEffect(() => {
        if (specialRegister) {
            document.body.classList.add('theme-special-category');
        } else {
            document.body.classList.remove('theme-special-category');
        }
        return () => {
            document.body.classList.remove('theme-special-category');
        };
    }, [specialRegister]);
    const {user, isLoggedIn} = useAuth();
    const {register, handleSubmit, formState: {errors}, watch, setValue} = useForm();
    const numChildren = watch("numero_hijos", "0");

    useEffect(() => {
        const prefillUserData = async () => {
            if (isLoggedIn && user && specialRegister) {
                let userDataToUse = location.state?.userData;
                if (!userDataToUse && user.sub) {
                    try {
                        const res = await axios.get(`${config.api_endpoint}/user/${user.sub}`);
                        userDataToUse = res.data;
                    } catch (e) {
                        console.error(e);
                    }
                }

                if (userDataToUse) {
                    if (userDataToUse.firstname) setValue("firstname", userDataToUse.firstname);
                    if (userDataToUse.lastname) setValue("lastname", userDataToUse.lastname);
                    if (userDataToUse.middle_name) setValue("middle_name", userDataToUse.middle_name);
                    if (userDataToUse.apellido_materno) setValue("apellido_materno", userDataToUse.apellido_materno);

                    if (userDataToUse.phone) {
                        let phone = userDataToUse.phone;
                        if (phone.startsWith("+52")) phone = phone.substring(3);
                        setValue("phone", phone);
                    }
                }

                if (user.email) {
                    setValue("email", user.email);
                }
            }
        };
        prefillUserData();
    }, [isLoggedIn, user, specialRegister, setValue, location.state]);

    const statesMexico = [
        "Aguascalientes", "Baja California", "Baja California Sur", "Campeche", "Chiapas", "Chihuahua", "Ciudad de México",
        "Coahuila", "Colima", "Durango", "Estado de México", "Guanajuato", "Guerrero", "Hidalgo", "Jalisco", "Michoacán",
        "Morelos", "Nayarit", "Nuevo León", "Oaxaca", "Puebla", "Querétaro", "Quintana Roo", "San Luis Potosí", "Sinaloa",
        "Sonora", "Tabasco", "Tamaulipas", "Tlaxcala", "Veracruz", "Yucatán", "Zacatecas"
    ];

    const levelsOfStudy = ["Preescolar", "Primaria", "Secundaria", "Preparatoria", "Preparatoria Tecmilenio", "Universidad"];
    const [response, setResponse] = useState(null)

    const [topping, setTopping] = useState("true");

    const onOptionChange = e => {
        setTopping(e.target.value)
    }

    const OnSubmit = async (data) => {
        // console.log(data)
        const emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        if (!emailRegex.test(data.email)) {
            const error_lang = context.langSpanish ? "* Email invalido" : "* Invalid email"
            setError(error_lang)
            toast(error_lang)
            return
        } else {
            setError(null)
        }

        if (data.password.indexOf(" ") !== -1) {
            const error_lang = context.langSpanish ? "* La contraseña no permite espacios " : "* The password does not allow blank spaces"
            setError(error_lang)
            toast(error_lang)
            return
        } else {
            setError(null)
        }

        if (data.password.length < 6) {
            const error_lang = context.langSpanish ? "* La contraseña debe tener minimo 6 caracteres " : "* The password must be at least six characters long"
            setError(error_lang)
            toast(error_lang)
            return
        } else {
            setError(null)
        }
        if (data.password !== data.password2) {
            const error_lang = context.langSpanish ? "* Password no coincide" : "* Password does not match"
            setError(error_lang)
            toast(error_lang)
            return
        } else {
            setError(null)
        }
        if (!specialRegister && data.phoneCode === "+52" && data.phone.length !== 10) {
            console.log(data.phone)
            console.log("falla en tamaño")
            const error_lang = context.langSpanish ? "* Por favor ingrese un número telefónico válido" : "* Pleas insert a valid phone number"
            setError(error_lang)
            toast(error_lang)
            return
        } else if (specialRegister && data.phone.length !== 10) {
            const error_lang = context.langSpanish ? "* Por favor ingrese un número telefónico de 10 dígitos" : "* Please insert a 10-digit phone number"
            setError(error_lang)
            toast(error_lang)
            return
        } else {
            setError(null)
        }

        if (!IsNumer(data.phone)) {
            console.log(data.phone)
            console.log(IsNumer(data.phone))
            const error_lang = context.langSpanish ? "* Por favor ingrese un número telefónico válido" : "* Pleas insert a valid phone number"
            setError(error_lang)
            return
        } else {
            console.log(IsNumer(data.phone))
            setError(null)
        }
        if (data.verificacion !== true) {
            const error_lang = context.langSpanish ? "* Para continuar es necesaria la conformidad con el aviso de privacidad" : "* To continue it is necessary accept the privacy notice"
            setError(error_lang)
            return
        } else {
            setError(null)
        }

        let contact_information = {
            Username: data.email,
            Password: data.password,
            UserAttributes: {
                name: data.name + " " + data.lastName,
                phone_number: `${data.phoneCode}${data.phone}`,
                email: data.email
            },
            country: data.country,
            name: data.name,
            lastName: data.lastName,
            organization: data.organization,
            verificacion: data.verificacion,
            terminos_proveedores: data.terminos_proveedores,
            interesado_evento_wellbeing: {topping},
            hs_language: context.signUpLang
        }

    setLoading(true)
    const message_lang = context.langSpanish ? "Se envío un correo de verificación por favor verifique su bandeja de" +
        "entrada" : "A verification email was sent please check your email"
    console.log(contact_information)
    axios["post"]('user-sign-up', JSON.parse(JSON.stringify(contact_information)))
        .then((res) => {
            setLoading(false);
            console.log(res)
            setResponse(res.data);
            // Track success in Facebook Pixel and TikTok Pixel
            try {
                ReactPixel.track('REGISTRATION', {status: 'success'});
            } catch (e) {
            }
            if (typeof window !== 'undefined' && window.ttq) {
                window.ttq.track('CompleteRegistration', {status: 'success'});
            }
            // LinkedIn: conversión de registro (si hay conversion_id configurado)
            if (typeof window !== 'undefined' && window.lintrk) {
                const regId = process.env.REACT_APP_LINKEDIN_CONVERSION_REG_ID;
                if (regId) {
                    try {
                        window.lintrk('track', {conversion_id: regId});
                    } catch (e) {
                        // silenciar opcionalmente
                    }
                } else {
                    if (process.env.NODE_ENV !== 'production') {
                        console.warn('LinkedIn: REACT_APP_LINKEDIN_CONVERSION_REG_ID no definido');
                    }
                }
            }
            if (specialRegister) {
                navigate('/thank-you?specialRegister=true');
            } else {
                navigate('/thank-you');
            }
        })
        .catch((err) => {
            toast(
                (t) => (
                    <div className="colorBlackToast">
                        <p className="pToast">{err.response.data.message}</p>
                        <button className="btn btn-danger button-purple buttonToast" onClick={() => {
                            toast.dismiss(t.id);
                        }}>Ok
                        </button>
                    </div>
                ), {duration: 20000,}
            );
            setLoading(false);
            setError(err.response.data.message);
        })
        .finally(() => {
            setLoading(false);
        });

}
const dropdownCodes = () => {
    return codes.map((code) =>
        <DropdownItem {...code}/>
    )

}
const dropdownCuntries = () => {
    return countries.map((country) =>
        <CountryItem {...country}/>
    )
}

const renderChildrenFields = () => {
    const count = numChildren === "+4" ? 4 : parseInt(numChildren);
    let fields = [];
    for (let i = 0; i < count; i++) {
        fields.push(
            <div key={`child-${i}`} className="child-fields-group mt-3">
                <p className="mb-2"><strong>Información del Hijo {i + 1}</strong></p>
                <div className="row">
                    <li className="pms-field col-md-6">
                        <label>Nivel de Estudios *</label>
                        <select {...register(`hijos.${i}.nivel_estudios`, {required: true})}>
                            <option value="">Selecciona nivel</option>
                            {levelsOfStudy.map(level => <option key={level} value={level}>{level}</option>)}
                        </select>
                    </li>
                    <li className="pms-field col-md-6">
                        <label>Escuela *</label>
                        <input {...register(`hijos.${i}.escuela`, {required: true})} className="input" type="text"/>
                    </li>
                </div>
            </div>
        );
    }
    return fields;
};

const renderNormalRegister = () => {
    return <div className="col-lg-12">
        <div className="text-center">
            <form id="pms_register-form" className="pms-form" autoComplete="off"
                  onSubmit={handleSubmit(OnSubmit)}>
                <div className="row">
                    <div className="col-md-12">
                        <p><FormattedMessage
                            id="SubscribeTxtHeaderForm"
                            defaultMessage="Suscríbete"
                        /></p>
                    </div>


                </div>
                <div className="row">
                    <div className="col-md-9">
                        <h4>
                            <FormattedMessage
                                id="SubscribeUp"
                                defaultMessage="Suscríbete"
                            />

                        </h4>
                    </div>

                    <div className="col-md-3">
                        <img src={logo} alt="Logo 360" className="sign-up-logo"/>
                    </div>

                </div>

                <ul className="pms-form-fields-wrapper pl-0">
                    <li className="pms-field pms-user-login-field ">
                        <label htmlFor="pms_user_login">
                            <FormattedMessage
                                id="subscribeName"
                                defaultMessage="Nombre *"
                            /></label>
                        <input {...register("name", {required: true})}
                               className="input" type="text" defaultValue=""/>
                    </li>
                    <li className="pms-field pms-first-name-field ">
                        <label htmlFor="pms_first_name">
                            <FormattedMessage
                                id="subscribeLastName"
                                defaultMessage="Apellido *"
                            /></label>
                        <input {...register("lastName", {required: true})}
                               className="input" type="text" defaultValue=""/>
                    </li>

                    <li className="pms-field pms-user-email-field ">
                        <label htmlFor="pms_user_email">
                            <FormattedMessage
                                id="subscribeMail"
                                defaultMessage="E-mail *"
                            /></label>
                        <input  {...register("email", {required: true})}
                                className="input" type="text" defaultValue=""/>
                    </li>
                    <li className="pms-field pms-first-name-field ">
                        <label htmlFor="pms_first_name">
                            <FormattedMessage
                                id="subscribePhone"
                                defaultMessage="Teléfono *"
                            />
                        </label>

                        <div className="row">
                            <select {...register("phoneCode", {required: true})}
                                    className="form-select col-md-6"
                                    aria-label="Default select example">
                                <option selected value="+52">+52</option>
                                {dropdownCodes()}
                            </select>

                            <input {...register("phone", {required: true})}
                                   className="input col-md-6" type="text" defaultValue=""/>
                        </div>
                    </li>
                    <li className="pms-field pms-first-name-field ">
                        <label htmlFor="pms_first_name">
                            <FormattedMessage
                                id="subscribeCountry"
                                defaultMessage="País/Región *"
                            /></label>
                        <select {...register("country", {required: true})}>
                            <option selected value="México">México</option>
                            {dropdownCuntries()}
                        </select>
                    </li>
                    <li className="pms-field pms-first-name-field ">
                        <label htmlFor="pms_organization">
                            <FormattedMessage
                                id="subscribeOrganization"
                                defaultMessage="Organización / Empresa *"
                            /></label>
                        <input {...register("organization", {required: true})}
                               className="input" type="text" defaultValue=""/>
                    </li>
                </ul>

                <div>
                    <ul className="pms-form-fields-wrapper pl-0">
                        <li className="pms-field pms-field-subscriptions ">
                            <p>
                                <FormattedMessage
                                    id="subscribePasswordMessage"
                                    defaultMessage="Tu contraseña debe tener minimo 6 caracteres"
                                />
                            </p>
                        </li>
                        <div className="row">
                            <li className="col-6">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="subscribePassword"
                                        defaultMessage="Contraseña *"
                                    />
                                </label>
                                <div className="password-input-wrapper">
                                    <input {...register("password", {required: true})}
                                           className="input" type={showPassword ? "text" : "password"} defaultValue=""/>
                                    <i
                                        className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'} password-toggle-icon`}
                                        onClick={() => setShowPassword(!showPassword)}
                                    />
                                </div>
                            </li>
                            <li className="col-6">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="subscribeRepeatPass"
                                        defaultMessage="Repetir Contraseña *"
                                    /></label>
                                <div className="password-input-wrapper">
                                    <input {...register("password2", {required: true})}
                                           className="input" type={showRepeatPassword ? "text" : "password"}
                                           defaultValue=""/>
                                    <i
                                        className={`fa ${showRepeatPassword ? 'fa-eye-slash' : 'fa-eye'} password-toggle-icon`}
                                        onClick={() => setShowRepeatPassword(!showRepeatPassword)}
                                    />
                                </div>
                            </li>
                        </div>
                    </ul>
                </div>
                <br/>

                <ul className=" pms-field pms-form-fields-wrapper pl-0">
                    <li className=" pms-field pms-field-subscriptions">
                        <div className="form-check">
                            <label>
                                <input {...register("verificacion", {required: false})}
                                       className="form-check-input" type="checkbox" defaultValue=""
                                       id="flexCheckVerification"/>
                                <label className="form-check-label" htmlFor="flexCheckDefault">
                                    <FormattedMessage
                                        id="subscribeVerification1"
                                        defaultMessage="He leído y acepto el"
                                    />
                                    {
                                        context.langSpanish ?
                                            <a href="https://www.wellbeing360.tv/privacy-policy-week">
                                                <FormattedMessage
                                                    id="subscribeVerification2"
                                                    defaultMessage=" aviso de privacidad "
                                                /></a>
                                            :
                                            <a href="https://www.wellbeing360.tv/privacy-policy-week">
                                                <FormattedMessage
                                                    id="subscribeVerification2"
                                                    defaultMessage=" aviso de privacidad "
                                                /></a>
                                    }

                                    <FormattedMessage
                                        id="subscribeVerification3"
                                        defaultMessage="para inscribirme y también deseo recibir información. *"
                                    />
                                </label>
                            </label>

                        </div>
                    </li>

                    <li className="pms-field pms-use pms-field pms-field-subscriptions">
                        <div className="form-check">
                            <label>
                                <input {...register("terminos_proveedores", {required: false})}
                                       className="form-check-input" type="checkbox" defaultValue=""
                                       id="flexCheckOferta"/>
                                <label className="form-check-label" htmlFor="flexCheckChecked">
                                    <FormattedMessage
                                        id="subscribeSuppliers"
                                        defaultMessage="Acepto ser contactado por aliados y patrocinadores para enviar
                                                        información acerca de eventos similares, ofertas, productos
                                                        y otros servicios"
                                    />
                                </label>
                            </label>

                        </div>
                    </li>

                    <li className="pms-field pms-use pms-field pms-field-subscriptions">
                        <div className="form-check">
                            <label>
                                <label className="form-check-label" htmlFor="flexCheckChecked">
                                    <FormattedMessage
                                        id="eventInformation"
                                        defaultMessage="¿Quieres recibir información de los eventos?"
                                    />
                                </label>
                                <p>
                                    <input {...register("event_topping", {required: false})}
                                           type="radio"
                                           name="topping"
                                           value="true"
                                           id="opcSi"
                                           checked={topping === "true"}
                                           onChange={onOptionChange}
                                    />
                                    <label htmlFor="si">SI</label>

                                    <input {...register("event_topping", {required: false})}
                                           type="radio"
                                           name="topping"
                                           value="false"
                                           id="opcNo"
                                           checked={topping === "false"}
                                           onChange={onOptionChange}
                                    />
                                    <label htmlFor="no">NO</label>
                                </p>
                            </label>
                        </div>
                        {/* <p>Select topping <strong>{topping}</strong></p> */}

                    </li>

                    <li className="pms-field pms-use pms-field pms-field-subscriptions">
                        {error ? (
                            <div className="login-error">
                                {error}
                            </div>
                        ) : null
                        }
                    </li>

                </ul>

                <ul className="pms-form-fields-wrapper pl-0">
                    <li className="pms-field pms-use pms-field pms-field-subscriptions">
                        {loading ?
                            (<div className="spinner-border text-light" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>) :
                            (<button type="submit" onSubmit={handleSubmit(OnSubmit)}>
                                                    <span className="screen-reader-text">
                                                        <FormattedMessage
                                                            id="subscribeContinue"
                                                            defaultMessage="Continuar"
                                                        /></span>
                            </button>)}
                    </li>
                </ul>

            </form>
        </div>
    </div>
}

return (
    <>
        <section className="position-relative pb-0">
            <div className="container">
                <div className="row">
                    {renderNormalRegister()}
                </div>
            </div>
        </section>
    </>
)
}

export default SignUp;
